var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"divide-y text-xs break-words"},[_c('OrderLine',{attrs:{"order-item":_vm.getRootOrderItem(_vm.orderItemParentOrderItem),"focused-order-item-id":_vm.current},on:{"order-line:focus":function($event){return _vm.$emit('order-line:changed', $event)}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }